import React from 'react';
import { Box, Typography } from '@mui/material';
import { McDrawer } from "@maersk-global/mds-react-wrapper/components-core/mc-drawer";
import { McButton } from "@maersk-global/mds-react-wrapper/components-core/mc-button";

const maerskFontFamily = '"Maersk Text", -apple-system, BlinkMacSystemFont, "Microsoft JhengHei", "Microsoft Yahei", "微软雅黑", STXihei, "华文细黑", sans-serif';

/**
 * RedChannelDrawer component displays a drawer with red channel applications
 * that require immediate attention due to security or compliance issues.
 */
const RedChannelDrawer = ({ 
  open, 
  onClose, 
  redChannelApplications = [] 
}) => {
  return (
    <McDrawer open={open} closed={onClose}>
      <span slot="heading" style={{ color: "#0073ab", fontFamily: maerskFontFamily }}>
        Red Channel Applications
      </span>
      <Box sx={{ mt: 2, mb: 3 }}>
        <Typography sx={{ fontSize: '0.95rem', color: '#6b7280', fontFamily: maerskFontFamily }}>
          Total: {redChannelApplications.length} application{redChannelApplications.length !== 1 ? 's' : ''}
        </Typography>
      </Box>
      <Box sx={{ overflowY: 'auto', pr: 1 }}>
        <Box>
          {redChannelApplications.length === 0 ? (
            <Box sx={{ py: 4, textAlign: 'center' }}>
              <Typography sx={{ color: '#6b7280', fontFamily: maerskFontFamily }}>
                No applications in Red Channel.
              </Typography>
            </Box>
          ) : (
            <Box sx={{ display: 'grid', gap: 2.5 }}>
              {redChannelApplications.map((app) => (
                <Box
                  key={app.applicationId}
                  sx={{
                    p: 2.5,
                    border: '1px solid #e5e7eb',
                    borderRadius: 2,
                    backgroundColor: '#ffffff'
                  }}
                >
                  <Typography 
                    sx={{ 
                      fontSize: '1rem',
                      color: '#0073ab', 
                      fontFamily: maerskFontFamily,
                    }}
                  >
                    {app.applicationId}
                  </Typography>
                  <Typography 
                    sx={{ 
                      fontSize: '0.9rem', 
                      color: '#374151', 
                      fontFamily: maerskFontFamily,
                      lineHeight: 1.6
                    }}
                  >
                    {app.instances.join(', ')}
                  </Typography>
                </Box>
              ))}
            </Box>
          )}
        </Box>
      </Box>
      <McButton slot="footer" dialogaction="close" onClick={onClose}>
        Close
      </McButton>
    </McDrawer>
  );
};

export default RedChannelDrawer;
